import { defineComponent as _defineComponent } from 'vue';
import { SButton } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
import onlineImg from '@/assets/images/index/online-img.png';
import onlineImg2x from '@/assets/images/index/online-img@x2.png';
import ResponsivePicture from '@/shared/ui/ResponsivePicture.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LandingSellOnlineSection',
  props: {
    title: null,
    text: null,
    items: null
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'LandingSellOnlineSection'
    });
    return {
      __sfc: true,
      SButton: SButton,
      onlineImg: onlineImg,
      onlineImg2x: onlineImg2x,
      ResponsivePicture: ResponsivePicture
    };
  }
});